import styled, { css } from 'styled-components';
import { Breakpoints } from '../../../styled/constants';

export const StyledSpaceSection = styled.div<{ $smallVerticalSpace?: boolean }>`
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.background.primary};
  border-radius: 14px;
  margin-bottom: 5px;

  ${({ $smallVerticalSpace }) =>
    $smallVerticalSpace &&
    css`
      padding-top: 10px;
      padding-bottom: 10px;
    `}

  @media (min-width: ${Breakpoints.tablet}px) {
    padding: 0;
    border-radius: 0;
    margin-bottom: 0;
  }

  @media (max-width: ${Breakpoints.tablet}px) {
    &:first-of-type {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
  }
`;
